module.exports = __webpack_public_path__ + "cd27916fe493e3ba15d973e2db88b346.pdf";